import {Button, Stack} from '@mui/material';
import i18n from 'i18n';

type CancelActionButtonsProps = {
    cancelText?: string;
    actionText?: string;
    isActionBtnDisabled?: boolean;
    handleClose: () => void;
};

export const CancelActionButtons = ({
    cancelText,
    actionText,
    handleClose,
    isActionBtnDisabled = false,
}: CancelActionButtonsProps) => {
    return (
        <Stack
            direction='row'
            justifyContent='flex-end'
            gap={1}
        >
            <Button
                onClick={handleClose}
                variant='outlined'
            >
                {cancelText || i18n.t('cancel', {ns: 'common'})}
            </Button>
            <Button
                variant='contained'
                type='submit'
                disabled={isActionBtnDisabled}
            >
                {actionText || i18n.t('download', {ns: 'common'})}
            </Button>
        </Stack>
    );
};
